export const setAreaLabelFromDb = (country, list) => {
  const relatedArea = list.filter(
    (f) => f.name.toLowerCase() === country.toLowerCase()
  )

  return relatedArea[0]?.area
}
